<template>
    <div id="chatbot" class="cb-class">
        <AppBreadCrumb :paths="[{ title: 'ChatBot' }]" :select="true">
            <div
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.showChatBot')"
                class="custom-checkbox2"
            >
                <a-switch v-model="chatBotEnabled" size="small">
                    <a-icon slot="checkedChildren" type="check" />
                    <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
                <span>{{ $t("message.chatBot") }}</span>
            </div>
        </AppBreadCrumb>

        <b-container v-if="isLoaded" class="mt-3" fluid>
            <b-row class="mx-0">
                <b-col lg="12">
                    <b-card class="vh100" no-body>
                        <b-card-body class="d-flex align-items-center flex-column overflow-auto pb-5">
                            <div v-if="!!!chatSteps.length" class="cb-start">
                                <div class="cb-button">
                                    <md-button
                                        class="text-white"
                                        @click="addStep({ key: 'content' }, null, false, true)"
                                    >
                                        {{ $t("chatbot.startToDesign") }}
                                    </md-button>
                                </div>
                                <BotDance />
                            </div>

                            <Step
                                v-if="!!chatSteps.length"
                                :add-step="addStep"
                                :path="path"
                                :select="
                                    (step, buttonClicked) => {
                                        selectedItem = step;
                                        if (!buttonClicked) visible = true;
                                    }
                                "
                                :selected="selectedItem"
                                :sidePanelVisible="visible"
                                :step="chatSteps[0]"
                            />
                        </b-card-body>
                    </b-card>
                </b-col>

                <a-drawer
                    :closable="false"
                    :visible="visible"
                    :width="550"
                    class="chatbotDrawer"
                    placement="right"
                    @close="update"
                >
                    <b-row v-if="selectedItem" class="cb-class h-100">
                        <b-col
                            v-if="selectedItem.type === 'content'"
                            class="px-3"
                            lg="2"
                            style="border-right: 1px solid #eeeeee"
                        >
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.text')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addItem('text')">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addText") }}
                                </button>
                            </div>
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.randomText')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addItem('random')">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addRandomText") }}
                                </button>
                            </div>
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.image')"
                                class="mx-0 mb-2 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addItem('image')">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addImage") }}
                                </button>
                            </div>
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.ticket')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addItem('ticket', true)">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addTicket") }}
                                </button>
                            </div>
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.goto')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addItem('goto')">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addGOTO") }}
                                </button>
                            </div>
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.link')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addItem('link')">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addLink") }}
                                </button>
                            </div>

                            <div class="mx-0 mb-2 p-0 add-actions-card">
                                <button class="m-0 p-0 button-content" @click="update" style="color: #3aad55">
                                    <md-icon style="color: #3aad55">save</md-icon>
                                    {{ $t("message.update") }}
                                </button>
                            </div>
                        </b-col>
                        <b-col
                            v-if="selectedItem.type === 'menu'"
                            class="px-0"
                            lg="2"
                            style="border-right: 1px solid #eeeeee"
                        >
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.button')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addButton">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addButton") }}
                                </button>
                            </div>
                            <div class="mx-0 mb-2 p-0 add-actions-card">
                                <button class="m-0 p-0 button-content" @click="update" style="color: #3aad55">
                                    <md-icon style="color: #3aad55">save</md-icon>
                                    {{ $t("message.update") }}
                                </button>
                            </div>
                        </b-col>
                        <b-col
                            v-if="selectedItem.type === 'form'"
                            class="px-0"
                            lg="2"
                            style="border-right: 1px solid #eeeeee"
                        >
                            <div
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('chatbot.question')"
                                class="mx-0 mb-2 p-0 add-actions-card"
                            >
                                <button class="m-0 p-0 button-content" @click="addInput">
                                    <md-icon>add</md-icon>
                                    {{ $t("message.addInput") }}
                                </button>
                            </div>
                            <div class="mx-0 mb-2 p-0 add-actions-card">
                                <button class="m-0 p-0 button-content" @click="update" style="color: #3aad55">
                                    <md-icon style="color: #3aad55">save</md-icon>
                                    {{ $t("message.update") }}
                                </button>
                            </div>
                        </b-col>

                        <b-col lg="10">
                            <div class="cb-container h-100 position-relative">
                                <div class="header p-3">
                                    <md-field class="bg-transparent m-0">
                                        <label>{{ $t("message.stepTitle") }}</label>
                                        <md-input type="text" v-model="selectedItem.description" />
                                    </md-field>
                                    <md-button class="cb-close-btn top-right-corner" @click="onDeleteStep">
                                        <md-icon style="color: red">delete</md-icon>
                                    </md-button>
                                    <div v-if="selectedItem.type === 'menu'" class="cb-text-checkboxes">
                                        <md-checkbox
                                            v-model="selectedItem.showPrevMenuButton"
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            :content="$t('chatbot.prev')"
                                            class="md-primary mb-0"
                                            type="checkbox"
                                        >
                                            {{ $t("message.prevStep") }}
                                        </md-checkbox>
                                        <md-checkbox
                                            v-model="selectedItem.showLiveChatButton"
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            :content="$t('chatbot.transferLiveChatOption')"
                                            class="md-primary mb-0"
                                            type="checkbox"
                                        >
                                            {{ $t("message.goToLive") }}
                                        </md-checkbox>
                                    </div>
                                    <div v-if="selectedItem.type === 'content'" class="cb-text-checkboxes">
                                        <md-checkbox
                                            v-if="selectedItem.nextStepId === null"
                                            v-model="selectedItem.closeChat"
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            :content="$t('chatbot.closeChat')"
                                            class="md-primary mb-0"
                                            type="checkbox"
                                        >
                                            {{ $t("message.closeChat") }}
                                        </md-checkbox>
                                    </div>
                                </div>

                                <div v-if="selectedItem.type === 'content'" class="aiTagList px-3">
                                    <a-divider>{{ $t("chatbot.keywords") }}</a-divider>
                                    <input
                                        v-show="(selectedItem.tags || []).length < 15"
                                        v-model="tag"
                                        :placeholder="$t('chatbot.typeKeyword')"
                                        class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                        style="height: 50px"
                                        @keydown.enter="addTag"
                                    />
                                    <md-chip
                                        v-for="(tag, i) in selectedItem.tags"
                                        :key="i"
                                        class="md-primary mt-3 user-select-none ml-0 mr-1"
                                        md-deletable
                                        style="height: 30px"
                                        @md-delete="selectedItem.tags.splice(i, 1)"
                                    >
                                        {{ tag }}
                                    </md-chip>
                                </div>

                                <div
                                    v-for="(textItem, i) in selectedItem.textItems"
                                    v-if="selectedItem.type === 'content'"
                                    :key="i"
                                    class="my-1 position-relative px-3 py-2 cb-hover-item cb-container"
                                >
                                    <a-divider style="margin: 10px 0 !important">
                                        {{ $t(`chatbot.types.${textItem.type}`) }}
                                    </a-divider>

                                    <button class="cb-hover-close-btn" @click="selectedItem.textItems.splice(i, 1)">
                                        <md-icon class="text-danger">delete</md-icon>
                                    </button>
                                    <button v-if="i !== 0" class="cb-hover-up-btn" @click="moveUp(i)">
                                        <md-icon class="text-info">arrow_upward</md-icon>
                                    </button>
                                    <button
                                        v-if="i !== selectedItem.textItems.length - 1"
                                        class="cb-hover-down-btn"
                                        @click="moveDown(i)"
                                    >
                                        <md-icon class="text-info">arrow_downward</md-icon>
                                    </button>

                                    <div v-if="textItem.type !== 'goto'" class="d-flex align-items-center">
                                        <div class="cb-slider-con">
                                            <label class="d-flex">
                                                <div
                                                    v-tippy="{
                                                        followCursor: true,
                                                        placement: 'bottom-end',
                                                    }"
                                                    :content="$t('chatbot.delay')"
                                                    class="cb-delay-btn d-inline bg-secondary text-white mr-3"
                                                >
                                                    <md-icon
                                                        style="
                                                            font-size: 14px !important;
                                                            color: white;
                                                            height: 100% !important;
                                                        "
                                                    >
                                                        alarm
                                                    </md-icon>
                                                    <span>{{ $t("chatbot.snDelay", { delay: textItem.delay }) }}</span>
                                                </div>
                                                <input class="cb-check-btn" type="checkbox" />
                                                <input
                                                    v-model="textItem.delay"
                                                    class="cb-text-range"
                                                    max="10"
                                                    min="0"
                                                    type="range"
                                                />
                                            </label>
                                        </div>
                                        <md-checkbox
                                            v-model="textItem.visible"
                                            class="md-primary m-0"
                                            style="margin-top: -7px !important"
                                            type="checkbox"
                                        >
                                            {{ $t("message.active") }}
                                        </md-checkbox>
                                    </div>

                                    <div v-if="textItem.type === 'text'" class="cb-text-item">
                                        <Mentionable :items="mentions" :keys="['@']" offset="6">
                                            <input
                                                :placeholder="$t('chatbot.contentTitle')"
                                                v-model="textItem.message"
                                                class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                                style="height: 50px; border-radius: 16px"
                                                type="text"
                                            />
                                        </Mentionable>
                                    </div>

                                    <div v-if="textItem.type === 'link'" class="cb-text-item">
                                        <input
                                            :placeholder="$t('chatbot.linkTitle')"
                                            v-model="textItem.message[0]"
                                            class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                            style="height: 50px; border-radius: 16px; text-decoration: underline"
                                            type="text"
                                        />
                                        <input
                                            :placeholder="$t('chatbot.linkAddress')"
                                            v-model="textItem.message[1]"
                                            class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                            style="height: 50px; border-radius: 16px"
                                            type="text"
                                        />
                                    </div>

                                    <div v-if="textItem.type === 'goto'" class="cb-text-item">
                                        <multiselect
                                            v-model="textItem.message"
                                            label="description"
                                            track-by="_id"
                                            :options="chatSteps.filter((x) => x._id !== selectedItem._id)"
                                            :multiple="false"
                                            class="stepItem"
                                            :placeholder="$t('message.selectStep')"
                                        />
                                    </div>

                                    <div v-if="textItem.type === 'ticket'" class="cb-text-item">
                                        <input
                                            :placeholder="$t('chatbot.subjectTitle')"
                                            v-model="textItem.ticketTopic"
                                            class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                            style="height: 50px; border-radius: 16px"
                                            type="text"
                                        />
                                        <Mentionable :items="mentions" :keys="['@']" offset="6">
                                            <input
                                                :placeholder="$t('chatbot.ticketSuccesfull')"
                                                v-model="textItem.message"
                                                class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                                style="height: 50px; border-radius: 16px"
                                                type="text"
                                            />
                                        </Mentionable>
                                    </div>

                                    <div v-if="textItem.type === 'random'" class="cb-text-item">
                                        <b-tabs activate-tab class="mt-2" :class="'textItemforTab-' + i">
                                            <b-tab v-for="(m, j) in textItem.message" :key="j">
                                                <template slot="title" class="bg-danger">
                                                    {{ j + 1 }}
                                                </template>
                                                <button
                                                    v-if="textItem.message.length > 2"
                                                    class="btnDeleteRandomMessage"
                                                    @click="deleteRandomMessage(i, j)"
                                                >
                                                    <md-icon class="text-danger">delete</md-icon>
                                                </button>
                                                <Mentionable :items="mentions" :keys="['@']" insert-space offset="6">
                                                    <input
                                                        v-model="selectedItem.textItems[i].message[j]"
                                                        :placeholder="$t('chatbot.randomTextPlaceHolder')"
                                                        class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                                        style="height: 50px"
                                                        type="text"
                                                    />
                                                </Mentionable>
                                            </b-tab>
                                            <b-tab
                                                :key="textItem.message.length"
                                                title="+"
                                                @click.prevent="selectedItem.textItems[i].message.push('')"
                                            ></b-tab>
                                        </b-tabs>
                                    </div>

                                    <div v-if="textItem.type === 'image'" class="cb-text-item d-flex">
                                        <div
                                            v-if="textItem.asset"
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            :content="$t('chatbot.imageView')"
                                            class="cb-img-preview position-relative"
                                        >
                                            <img
                                                :src="
                                                    'http://static.supsis.live/' +
                                                    textItem.asset.path +
                                                    textItem.asset._id
                                                "
                                                class="img-thumbnail ant-upload-list-picture-card-container"
                                                style="object-fit: cover"
                                            />
                                            <div
                                                class="cb-hover ant-upload-list-picture-card-container d-flex align-items-center justify-content-center"
                                                @click="
                                                    previewImg =
                                                        'http://static.supsis.live/' +
                                                        textItem.asset.path +
                                                        textItem.asset._id
                                                "
                                            >
                                                <md-icon class="text-white">visibility</md-icon>
                                            </div>
                                            <a-modal :footer="null" :visible="!!previewImg" @cancel="previewImg = null">
                                                <img :src="previewImg" style="width: 100%" />
                                            </a-modal>
                                        </div>

                                        <label
                                            v-tippy="{
                                                followCursor: true,
                                                placement: 'bottom-end',
                                            }"
                                            :content="$t('chatbot.upload')"
                                        >
                                            <div
                                                class="ant-upload ant-upload-select-picture-card"
                                                style="width: 50px; height: 50px"
                                            >
                                                <a-icon :type="textItem.asset ? 'edit' : 'plus'" class="ant-upload" />
                                            </div>
                                            <input
                                                :id="'imageItem-' + i"
                                                class="d-none"
                                                type="file"
                                                @change="(e) => uploadFile(e, i)"
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div v-if="selectedItem.type === 'menu'">
                                    <a-divider>{{ $t("chatbot.menuMessage") }}</a-divider>
                                    <div class="cb-text-item px-3">
                                        <input
                                            :placeholder="$t('chatbot.contentTitle')"
                                            v-model="selectedItem.textItems[0].message"
                                            class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                            style="height: 50px; border-radius: 16px"
                                            type="text"
                                        />
                                    </div>
                                    <a-divider>{{ $t("chatbot.selection") }}</a-divider>
                                    <div
                                        v-for="(menuItem, i) in selectedItem.menuItems"
                                        class="my-2 position-relative px-3 py-1 cb-hover-item cb-container"
                                    >
                                        <div class="d-flex">
                                            <button
                                                v-if="selectedItem.menuItems.length > 2"
                                                class="cb-hover-close-btn top-right-corner"
                                                @click="selectedItem.menuItems.splice(i, 1)"
                                            >
                                                <md-icon class="text-danger">delete</md-icon>
                                            </button>
                                            <button
                                                v-if="i !== 0"
                                                class="cb-hover-up-btn"
                                                @click="moveUp(i, 'menuItems')"
                                            >
                                                <md-icon class="text-info">arrow_upward</md-icon>
                                            </button>
                                            <button
                                                v-if="i !== selectedItem.menuItems.length - 1"
                                                class="cb-hover-down-btn"
                                                @click="moveDown(i, 'menuItems')"
                                            >
                                                <md-icon class="text-info">arrow_downward</md-icon>
                                            </button>
                                        </div>

                                        <div class="cb-text-item cb-menu-button py-3">
                                            <input
                                                :placeholder="$t('chatbot.buttonTitle')"
                                                v-model="menuItem.title"
                                                class="border-0 px-3 d-block mt-2 btn btn-info text-info bg-white"
                                                style="height: 50px; border-radius: 16px; margin: 0 auto"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div class="cb-text-item cb-menu-button">
                                        <button
                                            class="px-3 d-block mt-2 btn cb-menu-button-new"
                                            style="height: 30px; border-radius: 16px; margin: 0 auto"
                                            type="text"
                                            @click="addButton"
                                        >
                                            + {{ $t("chatbot.addNewButton") }}
                                        </button>
                                    </div>
                                </div>

                                <div
                                    v-for="(formItem, i) in selectedItem.formItems"
                                    v-if="selectedItem.type === 'form'"
                                    :key="i"
                                    class="my-1 position-relative px-3 input-items cb-hover-item cb-container"
                                >
                                    <div style="transform: translate(-20px, 20px)">
                                        <button class="cb-hover-close-btn" @click="selectedItem.formItems.splice(i, 1)">
                                            <md-icon class="text-danger">delete</md-icon>
                                        </button>
                                        <button v-if="i !== 0" class="cb-hover-up-btn" @click="moveUp(i, 'formItems')">
                                            <md-icon class="text-info">arrow_upward</md-icon>
                                        </button>
                                        <button
                                            v-if="i !== selectedItem.formItems.length - 1"
                                            class="cb-hover-down-btn"
                                            @click="moveDown(i, 'formItems')"
                                        >
                                            <md-icon class="text-info">arrow_downward</md-icon>
                                        </button>
                                    </div>
                                    <div class="cb-text-item">
                                        <input
                                            :placeholder="$t('chatbot.questionLabel')"
                                            v-model="formItem.key"
                                            class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                            style="height: 50px; border-radius: 16px"
                                            type="text"
                                        />
                                        <md-icon
                                            class="text-info"
                                            style="
                                                position: absolute;
                                                right: 26px;
                                                top: 69px;
                                                font-size: 40px !important;
                                            "
                                        >
                                            help_outline
                                        </md-icon>
                                        <input
                                            :placeholder="$t('chatbot.questionMessage')"
                                            v-model="formItem.description"
                                            class="w-100 bg-white border-0 px-3 d-block mt-2 stepItem"
                                            style="height: 50px; border-radius: 16px; padding-right: 50px !important"
                                            type="text"
                                        />
                                    </div>
                                    <a-divider />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </a-drawer>
            </b-row>
        </b-container>
        <b-spinner v-else />
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import Step from "../../components/Step";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import BotDance from "../../components/BotDance";
import { uploadAsset } from "../../api/assetUpload";
import axios from "axios";
import { systemMessageStream } from "../../utils/systemPubSub";
import { filter } from "rxjs/operators";
import { Mentionable } from "vue-mention";
import { sendSocketMessage } from "../../utils/socketStream";
import { log2 } from "../../utils/log2";
import ChatBar from "../../components/ChatBar";
import Multiselect from "vue-multiselect";

const log = log2("ChatBot");
export default {
    name: "ChatBot",
    components: {
        BotDance,
        AppBreadCrumb,
        Step,
        Mentionable,
        ChatBar,
        Multiselect,
    },
    data() {
        return {
            isLoaded: false,
            selectedItem: null,
            previewImg: null,
            path: [],
            visible: false,
            cachedItems: [],
            activeRandomTab: 0,
            mentions: [
                {
                    value: "email",
                    label: this.$t("message.email"),
                },
                {
                    value: "name",
                    label: this.$t("message.name"),
                },
            ],
            handleSave: _.debounce((newSettings) => {
                const isValid = Date.now() - (this.mountedTime || Date.now()) > 2000; // defaulttan gerçeğe geçerken bir kere sunucuya gitmesini engellemek için alternatif başka çözüm var sa yapalım
                log("handleSave runned", {
                    newSettings,
                    initialized: this.settingInitialized,
                    isValid,
                    mountedTime: this.mountedTime,
                    diff: Date.now() - (this.mountedTime || Date.now()),
                });
                if (isValid) {
                    this.submitClicked = true;
                    const self = this;
                    this.$validator.validateAll().then((response) => {
                        if (response) {
                            self.updateSettings(newSettings)
                                .then(() => {
                                    sendSocketMessage("admin settings-updated", {
                                        siteId: self.siteId,
                                    });
                                    self.$toasted.show(self.$t("message.settingsSaved"), {
                                        duration: 3000,
                                        position: "bottom-center",
                                    });
                                })
                                .finally(() => {
                                    self.submitClicked = false;
                                });
                        } else {
                            self.$toasted.error(self.$t("message.settingFormWrong"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        }
                    });
                }
            }, 1000).bind(this),
            tag: "",
        };
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            chatSteps: (state) => state.chatbot.chatbot.steps,
            siteId: (state) => state.site.site._id,
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
        }),
        chatBotEnabled: {
            get() {
                return this.settings.chatbot;
            },
            set(value) {
                const isPRO = _.get(this.settings, "plan.selectedPlan") === "pro";
                if (!isPRO) {
                    this.$toasted.error(this.$t("billing.mustBeUpgradePlanForChatBot"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                    return;
                }
                const newSettings = this.setSettingValue({
                    setting: "chatbot",
                    value: value,
                });
                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
    },
    methods: {
        ...mapActions({
            getAllSteps: "getAllSteps",
            createStep: "addStep",
            updateStep: "updateStep",
            deleteStep: "deleteStep",
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        addTag() {
            if (!this.selectedItem.tags) this.$set(this.selectedItem, "tags", []);
            if (!this.tag) return;
            this.selectedItem.tags = _.uniq([...this.selectedItem.tags, this.tag]);
            this.tag = "";
        },

        log(txt) {
            log("chatbot", txt);
        },

        beforeUpload(file) {
            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
            if (!isJpgOrPng) {
                this.$toasted.show(this.$t("chatbot.onlyImage"), {
                    duration: 3000,
                });
            }
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (!isLt2M) {
                this.$toasted.show(this.$t("chatbot.imageSize", { size: "20MB" }), {
                    duration: 3000,
                });
            }
            return isJpgOrPng && isLt2M;
        },
        async uploadFile(e, index) {
            let {
                files: [file],
            } = document.getElementById(e.target.id);
            if (!this.beforeUpload(file)) return;
            let path = `${this.siteId}/chatbot/${index}`;
            try {
                let imdUploadData = await uploadAsset({ path, mime: file.type });
                await axios({
                    method: imdUploadData.data.method,
                    url: imdUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": "application/octet-stream" },
                });
                this.selectedItem.textItems[index]["asset"] = imdUploadData.data.asset;
            } catch (e) {}
        },

        moveUp(i, type = "textItems") {
            this.selectedItem[type][i].order = i - 1;
            this.selectedItem[type][i - 1].order = i;
            let movedVal = this.selectedItem[type][i];
            this.$set(this.selectedItem[type], i, this.selectedItem[type][i - 1]);
            this.$set(this.selectedItem[type], i - 1, movedVal);
        },
        moveDown(i, type = "textItems") {
            this.selectedItem[type][i].order = i + 1;
            this.selectedItem[type][i + 1].order = i;
            let movedVal = this.selectedItem[type][i];
            this.$set(this.selectedItem[type], i, this.selectedItem[type][i + 1]);
            this.$set(this.selectedItem[type], i + 1, movedVal);
        },

        deleteRandomMessage(i, j) {
            this.selectedItem.textItems[i].message.splice(j, 1);
            let lastIndex = this.selectedItem.textItems[i].message.length;
            let elem = $(`.textItemforTab-${i} ul > li:nth-child(${lastIndex}) > a`)[0];
            if (elem) elem.click();
        },
        onDeleteStep() {
            this.$dialog
                .confirm(this.$t("chatbot.deleteChatBotStepQuestion"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    this.deleteStep(this.selectedItem._id).then(() => {
                        this.$toasted.show(this.$t("chatbot.chatbotStepWasDeleted"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                        const lastPath = _.last(this.path);
                        if (lastPath) {
                            const lastStep = this.chatSteps.find((x) => x._id === lastPath);
                            if (lastPath) {
                                this.selectedItem = _.last(this.chatSteps);
                            }
                        }

                        this.visible = false;
                    });
                });
        },

        addItem(type, isTicket = false) {
            let textItems = this.selectedItem.textItems;
            if (textItems.some((x) => x.type === "ticket") && isTicket) return;
            let model = {
                order: textItems.length,
                message: type === "random" ? ["", ""] : type === "link" ? ["", ""] : "",
                ticketTopic: isTicket ? this.$t("chatbot.subject") : null,
                type,
                delay: "1",
                visible: true,
                asset: null,
            };
            if (type === "menu") {
                model["menuItems"] = [
                    {
                        order: 0,
                        title: this.$t("chatbot.yes"),
                    },
                    {
                        order: 1,
                        title: this.$t("chatbot.no"),
                    },
                ];
            }
            this.selectedItem.textItems.push(model);
        },
        addButton() {
            let menuItems = this.selectedItem.menuItems;
            let model = {
                order: menuItems.length,
                title: this.$t("chatbot.menu") + (menuItems.length + 1),
            };
            this.selectedItem.menuItems.push(model);
        },
        addInput() {
            let formItems = this.selectedItem.formItems;
            this.cachedItems = [this.selectedItem, ...this.cachedItems.slice(0, 6)];
            let model = {
                key: "",
                order: formItems.length,
                description: "",
            };
            formItems.push(model);
            this.updateStep({ _id: this.selectedItem._id, formItems }).then(() => {
                this.selectedItem = this.chatSteps.find((x) => x._id === this.selectedItem._id);
            });
        },
        addStep({ key: type }, id, isButton = false, isStartStep = false) {
            const isPRO = _.get(this.settings, "plan.selectedPlan") === "pro";
            if (!isPRO) {
                this.$toasted.error(this.$t("billing.mustBeUpgradePlanForChatBot"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                return;
            }
            let menuItems = [];
            let textItems = [];
            let formItems = [];
            let title = isStartStep ? this.$t("chatbot.welcome") : this.$t("chatbot.untitled");
            if (type === "menu") {
                menuItems = [
                    {
                        order: 0,
                        title: this.$t("chatbot.menu") + 1,
                    },
                    {
                        order: 1,
                        title: this.$t("chatbot.menu") + 2,
                    },
                ];
                textItems.push({
                    delay: 1,
                    order: 1,
                    message: this.$t("chatbot.makeChoice"),
                    visible: true,
                    showTypingIndicator: true,
                    ticketTopic: null,
                    asset: null,
                    type: "text",
                });
                title = this.$t("chatbot.untitledMenu");
            }
            if (type === "form") {
                formItems.push({
                    order: 1,
                    description: this.$t("chatbot.descriptionUserName"),
                    key: this.$t("chatbot.userName"),
                });
                title = this.$t("chatbot.untitledForm");
            }
            return this.createStep({
                data: {
                    type,
                    menuItems,
                    textItems,
                    formItems,
                    description: title,
                },
                id,
            }).then((res) => {
                if (isButton) {
                    let menuItems = this.selectedItem.menuItems.map((x) => {
                        if (x._id === isButton._id) return { ...isButton, nextStepId: res._id };
                        return x;
                    });
                    this.updateStep({
                        _id: this.selectedItem._id,
                        menuItems,
                    }).then((res2) => {
                        this.selectedItem = res2;
                    });
                    return { ...isButton, nextStepId: res._id };
                }
            });
        },

        findPath() {
            let path = [];
            let maybePrev = this.chatSteps.find(
                (x) =>
                    x.nextStepId === this.selectedItem._id ||
                    x.menuItems.map((i) => i.nextStepId).includes(this.selectedItem._id)
            );
            while (maybePrev) {
                path.push(maybePrev._id);
                maybePrev = this.chatSteps.find(
                    (x) =>
                        x.nextStepId === maybePrev._id || x.menuItems.map((i) => i.nextStepId).includes(maybePrev._id)
                );
            }
            this.path = path;
        },

        update() {
            let {
                tags,
                textItems,
                menuItems,
                formItems,
                description,
                closeChat,
                showLiveChatButton,
                showPrevMenuButton,
                transferLiveChat,
            } = this.selectedItem;
            let payload = {
                tags,
                textItems,
                menuItems,
                formItems,
                description,
                closeChat,
                showLiveChatButton,
                showPrevMenuButton,
                transferLiveChat,
            };
            this.updateStep({ _id: this.selectedItem._id, ...payload }).then(() => {
                this.visible = false;
            });
        },
    },
    mounted() {
        this.mountedTime = Date.now();
    },
    created() {
        this.getAllSteps().then(() => {
            this.isLoaded = true;
            if (!!this.chatSteps.length) this.selectedItem = _.first(this.chatSteps);
        });
        systemMessageStream.pipe(filter((x) => x.type === "esc-keydown")).subscribe(() => {
            this.visible = false;
        });
    },
    watch: {
        selectedItem() {
            if (this.selectedItem !== null) this.findPath();
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.cb-class {
    .md-checkbox .md-checkbox-label {
        padding-left: 6px !important;
        height: auto !important;
        margin-bottom: 0 !important;
    }

    .nav-tabs {
        border: none !important;
    }

    .nav-item {
        margin-right: 4px;

        &:last-child {
            margin-right: 0px;
        }

        .nav-link {
            background-color: white !important;
            border: none !important;
            padding: 4px !important;
            width: 20px;
            height: 20px;
            text-align: center;
            font-size: 12px;
            color: black !important;
            border-radius: 20px;
            padding-top: 0px !important;

            &.active {
                background-color: #0e4d73 !important;
                color: white !important;
            }
        }
    }

    .ant-divider-inner-text {
        font-size: 10px !important;
        color: #6c757d !important;
    }

    .cb-img-preview {
        &:hover .cb-hover {
            opacity: 1;
        }

        .cb-hover {
            transition: all 0.3s;
            opacity: 0;
            position: absolute;
            z-index: 3;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #0c0c0c50;
            color: white;
            cursor: pointer;
        }
    }

    .vh100 {
        height: calc(100vh - 120px);
    }

    .cb-check-btn {
        display: none;

        & + .cb-text-range {
            display: none;
        }

        &:checked + .cb-text-range {
            display: block;
        }
    }

    .cb-close-btn {
        min-width: 32px;
        margin: 0;
    }

    .add-actions-card {
        .card-body {
            padding: 0.25rem;
        }

        .button-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            border: none;
            background-color: transparent;
            background-position: center;
            transition: background 0.8s;
            border-radius: 12px;
        }

        .button-content:hover {
            background: #e2e2e2 radial-gradient(circle, transparent 1%, #e2e2e2 1%) center/15000%;
        }

        .button-content:active {
            background-color: #ffffff;
            background-size: 100%;
            transition: background 0s;
        }
    }

    .top-right-corner {
        position: absolute;
        top: 0;
        right: 0;
    }

    .cb-text-item {
        .cb-text-checkboxes {
            display: flex;
            align-items: center;
            justify-content: space-around;
        }

        .cb-text-delay {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .cb-text-range {
                width: 80%;
            }
        }
    }

    .cb-container {
        background-color: #eee;
        border-radius: 12px;

        .header {
            background-color: white;
        }
    }

    .cb-delay-btn {
        border-radius: 12px;
        padding: 4px 8px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            background-color: #bbb !important;
        }
    }

    .cb-start {
        position: relative;

        .cb-button {
            background-color: #0f6674;
            position: absolute;
            top: 50%;
            transform: scale(2);
        }
    }

    .stepItem {
        &:focus,
        &:hover {
            border: 1px solid deepskyblue !important;
        }

        border-radius: 0 16px 16px 16px !important;
    }

    .cb-hover-close-btn,
    .cb-hover-up-btn,
    .cb-hover-down-btn {
        border: none;
        transition: all 0.3s;
        position: absolute;
        top: 50%;
        left: 0;
        background-color: #eeeeee;
        border-radius: 16px;
        transform: translate(-40%, -50%);
        opacity: 0;
        width: 20px;
        z-index: 9999999;
    }

    .cb-hover-up-btn {
        margin-top: 30px;
    }

    .cb-hover-down-btn {
        margin-top: 60px;
    }

    .cb-hover-item:hover {
        .cb-hover-close-btn,
        .cb-hover-up-btn,
        .cb-hover-down-btn {
            transform: translate(-70%, -50%);
            opacity: 1;
        }
    }

    .cb-menu-button {
        margin: 0 auto !important;

        .btn-info:hover {
            color: #138496 !important;
        }

        input {
            height: 30px !important;
        }
    }

    .cb-menu-button-new {
        color: #138496 !important;
        border: 1px dashed #138496;
        height: 30px !important;
        border-radius: 16px !important;
        margin: 0px auto !important;
    }
}

.chatbotDrawer {
    .ant-drawer-body {
        height: inherit !important;
    }
}

.btnDeleteRandomMessage {
    border: none !important;
    position: absolute;
    right: 16px;
    /* top: 51px; */
    margin-top: -30px;
    background: transparent;
}

.mention-item {
    padding: 4px 10px;
    border-radius: 4px;
}

.mention-selected {
    background: rgb(192, 250, 153);
}

.custom-checkbox2 {
    background-color: #f3f6f9;
    border-radius: 6px;
    padding: 3px 6px;
    max-width: 120px;
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-family: Poppins;
    font-weight: 400;
    font-size: 12px;
    color: #1e1e2d;
    margin-right: 6px;
}

.main {
    display: flex;
}

.columnL {
    flex: 77%;
    border-radius: 10px;
    margin-right: 10px;
}

.panel {
    flex-direction: row;
    flex-wrap: wrap;
}

.mycard {
    flex: 20%;
    margin: 5px;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
    background: #b1b1b1;
    z-index: 2;
}

.mycard:hover {
    border: 2px solid lightskyblue;
}
</style>
